import React from "react";
import { Button, Form, Input, message } from "antd";
import { useDispatch } from "react-redux";
import "../style/loginStyle.css";
import { userLogin } from "../store/actions/authAction";
import { useForm } from "antd/es/form/Form";
import { useTranslation } from "react-i18next";


const onFinishFailed = (errorInfo) => {
  message.error(errorInfo, 4);
};

const Login = () => {
  const { t } = useTranslation();
  const [form] = useForm();
  const dispatch = useDispatch();
  const onFinish = (values) => {
    dispatch(userLogin(values))
      .unwrap()
      .then((res) => {
        // handle result here
        localStorage.setItem("cardsToken", JSON.stringify(res.token));
        message.success(res.msg, 4);
        form.resetFields();
       window.location.href ="/";
      })
      .catch((err) => {
        // handle error here
        message.error(String(err), 4);
      });
  };
  return (
    <div className="login_page d-flex flex-column align-items-center justify-content-center">
      <h1 className="text-center mb-4"> {t("HEADING.LOGINTITLE")} </h1>
      <Form
        name="login"
        initialValues={{ username: "", password: "" }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Form.Item
          label={t("FORM.USERNAME")}
          name="username"
          rules={[{ required: true, message: "Please input your username!" }]}
        >
          <Input style={{ height: 40 }} />
        </Form.Item>

        <Form.Item
           label={t("FORM.PASSWORD")}
          name="password"
          rules={[{ required: true, message: "Please input your password!" }]}
        >
          <Input.Password style={{ height: 40 }} />
        </Form.Item>
        <Form.Item label={null}>
          <Button
            className="d-block w-100 fs-5"
            style={{ height: 45 }}
            type="primary"
            htmlType="submit"
          >
            {t("BUTTONS.LOGIN")}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default Login;
